import moment from 'moment';

export const checkMeetingTime = (start: Date, end: Date) => {
  const currentTime = moment();
  const startTime = moment(start);
  const endTime = moment(end);

  return currentTime.isBetween(startTime, endTime);
};
